export const CAMPAIGN_SALES_ROUTES = [
  { variantKey: "biznis", path: "/biznis" },
  { variantKey: "strah", path: "/strah" },
  { variantKey: "konsultanti", path: "/konsultanti" },
  { variantKey: "eksperti", path: "/eksperti" },
];

export const CAMPAIGN_SALES_PATHS = CAMPAIGN_SALES_ROUTES.map(
  ({ path }) => path
);

export const CAMPAIGN_SALES_ROUTE_PATHS = Object.fromEntries(
  CAMPAIGN_SALES_ROUTES.map(({ variantKey, path }) => [variantKey, path])
);
